import {
  Component,
  Input,
  ViewChild } from '@angular/core';
import { FlowManagerService } from '../../shared/services/flowmanager.service';

@Component({
  selector: 'ns-page-error',
  template: require('./pageError.component.html')
})

export class PageErrorComponent {
  @Input() errorObj;
  @ViewChild('focusItem') focusItem;

  constructor(flowmanager: FlowManagerService) {
    this.flowManager = flowmanager;
    this.errorTitle = 'Complete all the fields below before clicking next.';
  }

  ngAfterViewInit() {
    if (this.focusItem) {
      document.getElementById('banner-focus').focus();
    }
    const pageTop = document.querySelector('.main-container');
    scrollTo(document.body, pageTop.offsetTop, 0);
  }

  ngOnChanges() {
    this.errorBody = (this.errorObj.errorCount > 1) ? `There are ${this.errorObj.errorCount} 
    errors on this form.` : 'There is 1 error on this form.';
  }

  closeSubmitError() {
    this.flowManager.pageError = { hasErrors: false, errorCount: 0 };
  }
}
